import React, { useContext } from "react";
import ContentWrapper from "../components/wrappers/ContentWrapper";
// import ScaleWrapper from "../components/wrappers/ScaleWrapper";
import AppConfig from "./../config";

import { Navigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";

import { CircularProgress, Box, Typography } from "@mui/material";

export default function PrivateRoutes({ element: Component, ...rest }) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { loggedIn, loading } = useContext(AuthContext);

  // console.log("user", user);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh", // Ensures the content takes full screen height
          backgroundColor: "#fff", // Optional: Sets a background color
        }}
      >
        <CircularProgress sx={{ color: AppConfig.colorPalette.primary.main }} />{" "}
        {/* Optional: Spinner for visual feedback */}
        <Typography
          variant="h6"
          sx={{ color: AppConfig.colorPalette.primary.main }}
        >
          Please wait while we authorize you...
        </Typography>
      </Box>
    );
  }

  return (
    <ContentWrapper>
      {/* <ScaleWrapper scale={isMobile ? 0.8 : 0.9}> */}
      {loggedIn ? <Component {...rest} /> : <Navigate to="/login" />}
      {/* </ScaleWrapper> */}
    </ContentWrapper>
  );
}
